export default "https://cdn-static.gokick.com/assets/24c3578bda803cdf114b208e53f44151315faa60/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";